import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Log error to console for development
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  }

  handleGoHome = () => {
    window.location.href = '/';
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 via-pink-50 to-red-100 dark:from-gray-900 dark:via-red-900/20 dark:to-gray-900 px-4">
          <div className="max-w-2xl w-full text-center">
            {/* Error Icon */}
            <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-r from-red-500 to-pink-600 rounded-full mb-8 animate-pulse">
              <span className="material-symbols-outlined text-white text-6xl">error</span>
            </div>

            {/* Error Content */}
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
              Ops! Algo deu errado
            </h1>
            
            <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">
              Encontramos um erro inesperado. Nossa equipe foi notificada e está trabalhando para resolver.
            </p>

            {/* Error Details for Development */}
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="bg-gray-100 dark:bg-gray-800 rounded-xl p-6 mb-8 text-left max-w-lg mx-auto">
                <h3 className="font-bold text-red-600 dark:text-red-400 mb-2">Detalhes do Erro (Dev Mode):</h3>
                <p className="text-sm text-gray-700 dark:text-gray-300 font-mono">
                  {this.state.error.toString()}
                </p>
                {this.state.errorInfo.componentStack && (
                  <details className="mt-2">
                    <summary className="text-sm text-gray-600 dark:text-gray-400 cursor-pointer">
                      Component Stack
                    </summary>
                    <pre className="text-xs text-gray-600 dark:text-gray-400 mt-2 whitespace-pre-wrap">
                      {this.state.errorInfo.componentStack}
                    </pre>
                  </details>
                )}
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={this.handleReload}
                className="bg-gradient-to-r from-primary to-blue-600 hover:from-primary/90 hover:to-blue-700 text-white px-8 py-4 rounded-xl font-bold transition flex items-center justify-center gap-2 shadow-lg"
              >
                <span className="material-symbols-outlined">refresh</span>
                Tentar Novamente
              </button>
              
              <button
                onClick={this.handleGoHome}
                className="bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-900 dark:text-white border-2 border-gray-300 dark:border-gray-600 px-8 py-4 rounded-xl font-bold transition flex items-center justify-center gap-2"
              >
                <span className="material-symbols-outlined">home</span>
                Voltar ao Início
              </button>
            </div>

            {/* Help Text */}
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-8">
              Se o problema persistir, entre em contato conosco pelo WhatsApp: 
              <a 
                href="https://wa.me/5511999999999" 
                className="text-primary hover:underline ml-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                (11) 99999-9999
              </a>
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;